import { createAction } from '@ngrx/store';

export const startLoading = createAction('[Layout] Start Loading');
export const stopLoading = createAction('[Layout] Stop Loading');

export const setMessageToast = createAction('[Layout] Set Message Toast', (message: string) => ({ message }) );
export const clearMessageToast = createAction('[Layout] Clear Message Toast');

export const setDarkMode = createAction('[Layout] Set Dark Mode On', (darkMode) => ({ darkMode })  );
export const setTitle = createAction('[Layout] Set Title', (title: string) => ({ title: title }) );

export const setToggleSidenav = createAction('[Layout] Toggle Sidenav', (toggleSidenav) => ({toggleSidenav}));

